// extracted by mini-css-extract-plugin
export var TopNav = "TopNavigation-module--TopNav--0672c";
export var TopNavButton = "TopNavigation-module--TopNavButton--863c4";
export var TopNavCarbonLink = "TopNavigation-module--TopNavCarbonLink--20255";
export var TopNavInner = "TopNavigation-module--TopNavInner--3bdc1";
export var TopNavLargeLogo = "TopNavigation-module--TopNavLargeLogo--1a433";
export var TopNavLink = "TopNavigation-module--TopNavLink--6aeb5";
export var TopNavLinks = "TopNavigation-module--TopNavLinks--679ef";
export var TopNavSmallLogo = "TopNavigation-module--TopNavSmallLogo--adccc";